import { DataFormat } from "utils/format/DataFormat";

export abstract class TransactionHistoryRequestModel {
  status?: number;
  code?: string;
  carrier?: Array<string>;
  phoneNumber?: string;
  page?: number;
  limit?: number;
  pagination?: boolean;
  fromDate?: string;
  type?: number;
  toDate?: string;
  store?: Array<string>;
  staff?: Array<string>;
  isOnlyStore?: string;
  isdnOrIccid?: string;
  created?: Array<Record<string, unknown>>;
  order?: string;

  public removeUnknowValue<T extends TransactionHistoryRequestModel>(data: T) {
    return DataFormat.removeUndefined(
      data as unknown as Record<string, unknown>
    );
  }
}
